import { MessageBarType } from "@fluentui/react";

export enum TranslatedSettings {
  calculationRationale = "Racional de cálculo:",
  creditApprovalMessage = "Mensagem de aprovação de crédito:",
  defaultPhoneAreaCode = "Código padrão de área do telefone:",
  hasContractActivationFee = "Possui valor de ativação de contrato:",
  newsLink = "Novidades:",
  offersLink = "Pacotes de Benefícios:",
  paymentMethod = "Método de Pagamento:",
  powerbi = "Power BI:",
  promotionsLink = "Promoções:",
  sandbox = "Sandbox:",
  signers = "Signatário(s):"
}

export enum TranslatedContactsTypes {
  WHATSAPP = "WhatsApp",
  PHONE_NUMBER = "Telefone",
  EMAIL = "Email"
}

export enum BusinessUnitPaymentMethod {
  BOLETO = "BOLETO",
  DEBITO_AUTOMATICO = "DEBITO_AUTOMATICO",
  PRE_PAGO = "PRE_PAGO",
  DEBITO_EM_FOLHA = "DEBITO_EM_FOLHA",
  FATURA_PIX = "FATURA_PIX"
}

export enum TranslatedBusinessUnitPaymentMethod {
  BOLETO = "Boleto",
  DEBITO_AUTOMATICO = "Débito automático",
  PRE_PAGO = "Pré-pago",
  DEBITO_EM_FOLHA = "Débito em folha",
  FATURA_PIX = "Fatura Pix"
}

export enum BUType {
  AUTONOMOUS = "AUTONOMOUS",
  NOT_AUTONOMOUS = "NOT_AUTONOMOUS"
}

export interface ISigner {
  id: number;
  name: string;
  email: string;
  documentNumber: string;
  digitalSignatureType: string;
  birthDate: string;
  contractSignature: {
    id: number;
    status: boolean;
    documentNumber: string;
    externalKey: string;
    signerSecret: string | null;
    eletronicSignature: {
      id: number;
      status: boolean;
      name: string;
      signerName: string;
      signerEmail: string;
      signerBirthday: string;
      signerDocument: string;
      externalIntegrationUrl: string;
      externalIntegrationSecret: string;
    };
  };
}

export interface ISignerFormState {
  show?: boolean;
  isSubmitting?: boolean;
  message?: string;
  messageType?: MessageBarType;
  secret?: string;
}

export interface ISignerFormsState {
  [signerEmail: string]: ISignerFormState;
}
